import { render, staticRenderFns } from "./IcoContentPile.vue?vue&type=template&id=24e9934e"
import script from "./IcoContentPile.vue?vue&type=script&lang=js"
export * from "./IcoContentPile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports